module.exports = __webpack_public_path__ + "static/media/galerija_2022_0051.fab92663.jpg";